import React from 'react'
import StyleSheet from 'styles'

export default svg => ({className='', background = 'transparent', color = '#FFF', width = 24, height = 24, style}) =>
  <span style={{fill: color, width, height, background, ...style}} className={`${styles.svgContainer} ${className}`}>
    {svg}
  </span>

const styles = StyleSheet({
  svgContainer: {
    '& svg': {
      width: '100%',
      height: '100%'
    },
    display: 'inline-block'
  }
})